// |-- Built-in Dependencies --|
import React from "react";
import { FormikProps } from "formik";

// |-- Internal Dependencies --|
import { FormInitialValues } from "../Add/AddDispositionLevelTwoFormWrapper";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";

// |-- Types --|
type Props = {
  formType: "Add" | "Edit";
  onClose: () => void;
  formikProps: FormikProps<FormInitialValues>;
};

const DispositionLevelTwoForm = ({ formType, onClose, formikProps }: Props) => {
  const { values, setFieldValue, handleBlur, isSubmitting, handleSubmit } =
    formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "Edit" ? "Update" : "Add"} disposition second
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <ATMTextField
          name="dispositionLevelSecondName"
          value={values.dispositionLevelSecondName}
          placeholder="Enter disposition second name"
          label="Disposition Second Name "
          onBlur={handleBlur}
          onChange={(e) => {
            setFieldValue("dispositionLevelSecondName", e.target.value);
          }}
        />
      </div>
      <div>
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          onClick={() => handleSubmit()}
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default DispositionLevelTwoForm;
